module.exports = __webpack_public_path__ + "img/arrow_left.fef75b8.svg";